import { useCallback, useEffect, useRef, useState } from 'react';

export const useHeroMotion = () => {
  const ref = useRef(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    let frame = 0;
    const onScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setScrollY(window.scrollY));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => { window.removeEventListener('scroll', onScroll); cancelAnimationFrame(frame); };
  }, []);

  const onMouseMove = useCallback((event) => {
    const node = ref.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    node.style.setProperty('--x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
    node.style.setProperty('--y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
  }, []);
  return { ref, onMouseMove, scrollY };
};